import React, { useState } from "react";
import MainExpenses from "./main";
import MainCategory from "./category/main";
import MainSubCategory from "./subcategory/main";
import MainDescription from "./description/main";
import MainTarget from "./Targets/main";
import MainTargetList from './NewTargetList/main';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import BackLogo from '../../../../../images/rewampimages/Chevron.png'
import SettingsIcon from '@mui/icons-material/Settings';
import WalletIcon from '@mui/icons-material/Wallet';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import VendorMain from './VendorMaster/main'
import NewExpense from './Newexpense/Main'
import ExpenseIcon from './Newexpense/assets/theme-expense-icon.svg';
import TargetIcon from './Newexpense/assets/theme-target-icon.svg';
import ConfigIcon from './Newexpense/assets/theme-config-icon.svg';
const TabsExpense = ({ pageViewHandler, admin }) => {
    const [viewState, setViewState] = useState('newExpenseDashboard')
    const [configState, setconfigState] = useState('')

    const BackBtnStyle = {
        color: '#223d64',
        fontWeight: '400',
        display: 'flex',
        border: '1px solid #006c67',
        borderRadius: '6px',
        padding: '8px 10px',
        marginLeft: viewState === 'expense' || viewState === 'target' ? '0px' : '80px',
    }
    const BackBtnStyle2 = {
        color: '#fff',
        fontWeight: '400',
        display: 'flex',
        background: '#006c67',
        cursor: 'pointer',
        padding: '12px 20px',
        'boxShadow': 'inset -4px -4px 4px 0px #1d252d'
    }


    const handeNavbarState = (e, type) => {
        if (type == 'expense' || type == 'targetNewList' || type == "newExpenseDashboard") {
            setconfigState('')
            setViewState(type)
        } else if (type == 'config') {
            setconfigState(type)
            setViewState('category')
        }
    }

    return (
        <>
            {
                viewState !== 'newExpenseDashboard'
                    ?
                    <div className="container-fluid details-new fixed-top" style={{ zIndex: '10' }} >
                        <div className="row details-new-tab-div" style={{ display: 'flex', justifyContent: 'end' }}>
                            <div className="col-sm-6 col-xs-12 " style={{ marginTop: '15px' }}>
                                <img onClick={(e) => pageViewHandler(e, 'landingPage')} style={{ cursor: 'pointer' }} src={BackLogo} width={'30px'} /> <button style={{ color: '#1D3557', fontWeight: '700' }} onClick={(e) => pageViewHandler(e, 'landingPage')} >Back</button>
                            </div>

                            <div className=" col-lg-6 col-xs-12" style={{ fontSize: '10px', display: 'flex', justifyContent: 'end' }}>


                                {/* <div className="btn-group-new">

                                    <button className={(viewState === 'newExpenseDashboard') ? "active" : ""} onClick={(e) => handeNavbarState(e, 'newExpenseDashboard')}><WalletIcon style={{ fontSize: '27px' }} /><br />Expense Dashboard</button>
                                    <button className={(viewState === 'expense') ? "active" : ""} onClick={(e) => handeNavbarState(e, 'expense')}><WalletIcon style={{ fontSize: '27px' }} /><br />Expense List</button>
                                    <button className={(viewState === 'targetNewList') ? "active" : ""} onClick={(e) => handeNavbarState(e, 'targetNewList')}><TrackChangesIcon style={{ fontSize: '27px' }} /><br />Target List</button>
                                    <button className={(configState === 'config') ? "active" : ""} onClick={(e) => handeNavbarState(e, 'config')}><SettingsIcon style={{ fontSize: '27px' }} /><br />Expense Configuration</button>
                                </div> */}
                                <div className="btn-group-new-new">

                                    <button className={(viewState === 'newExpenseDashboard') ? "active" : ""} onClick={(e) => handeNavbarState(e, 'newExpenseDashboard')}>
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <rect x="3" y="3" width="7" height="7"></rect>
                                            <rect x="14" y="3" width="7" height="7"></rect>
                                            <rect x="14" y="14" width="7" height="7"></rect>
                                            <rect x="3" y="14" width="7" height="7"></rect>
                                        </svg>
                                        <span>Expense Dashboard</span>
                                    </button>
                                    <button className={(viewState === 'expense') ? "active" : ""} onClick={(e) => handeNavbarState(e, 'expense')}>
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <path d="M9 11H3v10h6V11z"></path>
                                            <path d="M21 3h-6v18h6V3z"></path>
                                            <path d="M15 7H9v14h6V7z"></path>
                                        </svg>
                                        <span>Expense List</span>
                                    </button>
                                    <button className={(viewState === 'targetNewList') ? "active" : ""} onClick={(e) => handeNavbarState(e, 'targetNewList')}>
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <circle cx="12" cy="12" r="10"></circle>
                                            <circle cx="12" cy="12" r="6"></circle>
                                            <circle cx="12" cy="12" r="2"></circle>
                                        </svg>
                                        <span>Target List</span>
                                    </button>
                                    <button className={(configState === 'config') ? "active" : ""} onClick={(e) => handeNavbarState(e, 'config')}>
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <circle cx="12" cy="12" r="3"></circle>
                                            <path d="M12 1v6m0 6v6m4.22-13.22l4.24 4.24M1.54 9.96l4.24 4.24m12.44 0l4.24 4.24M1.54 14.04l4.24-4.24"></path>
                                        </svg>
                                        <span>Expense Configuration</span>
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                    : ''}
            {
                configState === 'config' ?
                    <div className="row fixed-top" style={{ marginTop: '75px', display: 'flex', width: '101%' }}>

                        <div className={`expenseListTab ${viewState == "category" ? "active" : ""}`} onClick={() => setViewState('category')} style={{ background: '#DBE9FF', textAlign: 'center', width: '25%', borderRadius: '0' }}>
                            Expense Category

                        </div>
                        <div className={`expenseListTab ${viewState == "subCategory" ? "active" : ""}`} onClick={() => setViewState('subCategory')} style={{ background: '#DBE9FF', textAlign: 'center', width: '25%', borderRadius: '0' }}>
                            Expense  Sub-Category

                        </div>
                        <div className={`expenseListTab ${viewState == "description" ? "active" : ""}`} onClick={() => setViewState('description')} style={{ background: '#DBE9FF', textAlign: 'center', width: '25%', borderRadius: '0' }}>
                            Expense Description

                        </div>
                        <div className={`expenseListTab ${viewState == "target" ? "active" : ""}`} onClick={() => setViewState('target')} style={{ background: '#DBE9FF', textAlign: 'center', width: '25%', borderRadius: '0' }}>
                            Expense Target

                        </div>
                        <div className={`expenseListTab ${viewState == "Vendor" ? "active" : ""}`} onClick={() => setViewState('Vendor')} style={{ background: '#DBE9FF', textAlign: 'center', width: '25%', borderRadius: '0' }}>
                            Vendor

                        </div>


                    </div>
                    : ''}
            {/* <div className={viewState === 'expense' || viewState === 'target' ? "container-fluid" : "container"}>
                <div className="row">
                    <div className="col-sm-4 " style={{ marginTop: window.innerWidth > 1800 ? '0%' : '5%'}}>
                        <button style={BackBtnStyle} onClick={(e) => pageViewHandler(e, 'landingPage')} ><ArrowBackIosNewIcon style={{ marginTop: '1px' }} />&nbsp;Back</button>
                    </div>
                </div>
            </div> */}
            <div className="" style={{ marginTop: viewState === 'expense' ? window.innerWidth > 1800 ? '0%' : '6%' : window.innerWidth > 1800 ? '8%' : '9%' }}>

                {viewState === 'expense' ?
                    <MainExpenses admin={admin} pageViewHandler={pageViewHandler} />
                    : ""}
                {viewState === 'category' ?
                    <MainCategory />
                    : ""}
                {viewState === 'subCategory' ?
                    <MainSubCategory />
                    : ""}
                {viewState === 'description' ?
                    <MainDescription />
                    : ""}
                {viewState === 'target' ?
                    <MainTarget />
                    : ""}
                {viewState === 'targetNewList' ?
                    <MainTargetList />
                    : ""}
                {viewState === 'Vendor' ?
                    <VendorMain />
                    : ""}

            </div>

            {viewState === 'newExpenseDashboard' ?
                <NewExpense handeNavbarState={handeNavbarState} pageViewHandler={pageViewHandler}/>
                : ""}
        </>
    )
}
export default TabsExpense